import React, { useState } from 'react';
import { Box, Button, Typography, Container, Alert } from '@mui/material';
import Input from '../components/Input';
import { useAuth } from '../context/AuthContext';

export default function ForgotPassword() {
  const { resetPassword } = useAuth();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState({ success: false, error: null });

  const handleSubmit = async (event) => {
    event.preventDefault();
    const result = await resetPassword(email);
    setStatus(result);
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          border: '1px solid #ccc',
          borderRadius: '10px',
          padding: '20px',
          bgcolor: (theme) => theme.palette.mode === 'light'
            ? 'rgba(255, 255, 255, 0.9)'
            : 'rgba(35, 35, 35, 0.9)',
          boxShadow: '0px 3px 15px rgba(0, 0, 0, 0.1)'
        }}
      >
        <Typography component="h1" variant="h5">
          Forgot Password
        </Typography>
        {status.error && (
          <Alert severity="error" sx={{ mt: 2, width: '100%' }}>
            {status.error}
          </Alert>
        )}
        {status.success && (
          <Alert severity="success" sx={{ mt: 2, width: '100%' }}>
            Password reset email sent successfully!
          </Alert>
        )}
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <Input
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Send Reset Email
          </Button>
        </Box>
      </Box>
    </Container>
  );
} 